import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["level", "icon", "label", "expandedList", "childNodes", "expanded", "isMobile", "isPrimary", "lineHeight", "nodeId"];
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { Box, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { StyledNavItemRoot } from './verticalNavStyles';
import { VerticalNavDot } from './verticalNavDot';
import classNames from 'classnames';
export var StyledNavItem = function StyledNavItem(props) {
  var level = props.level,
    icon = props.icon,
    label = props.label,
    expandedList = props.expandedList,
    childNodes = props.childNodes,
    expanded = props.expanded,
    isMobile = props.isMobile,
    isPrimary = props.isPrimary,
    _props$lineHeight = props.lineHeight,
    lineHeight = _props$lineHeight === void 0 ? 0 : _props$lineHeight,
    nodeId = props.nodeId,
    otherProps = _objectWithoutProperties(props, _excluded);
  var labelIcon = /*#__PURE__*/React.createElement(VerticalNavDot, {
    level: level
  });
  if (isPrimary) {
    if (typeof icon === 'string') {
      labelIcon = /*#__PURE__*/React.createElement(Box, {
        component: "span",
        className: icon
      });
    } else {
      labelIcon = icon;
    }
  }
  return /*#__PURE__*/React.createElement(ListItem, {
    disableGutters: true,
    disablePadding: true
  }, /*#__PURE__*/React.createElement(StyledNavItemRoot, _extends({}, otherProps, {
    tabIndex: 0,
    role: "button",
    className: classNames('EmbersNav-item', {
      'EmbersNav-primary': isPrimary,
      'EmbersNav-expanded': expanded,
      'EmbersNav-hasChildren': childNodes === null || childNodes === void 0 ? void 0 : childNodes.length,
      'Embers-selected': otherProps.selected,
      'Embers-disabled': otherProps.disabled
    }),
    "aria-expanded": childNodes !== null && childNodes !== void 0 && childNodes.length ? expanded : void 0,
    "aria-current": otherProps.selected ? otherProps['aria-current'] || 'page' : 'false',
    styles: {
      isMobile: isMobile,
      indent: 24 * level - 2,
      lineHeight: lineHeight
    },
    style: {
      display: 'flex'
    }
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItemIcon, {
    "aria-hidden": true
  }, labelIcon), /*#__PURE__*/React.createElement(ListItemText, {
    className: "EmbersNav-label-text",
    primary: label
  }), !!(childNodes !== null && childNodes !== void 0 && childNodes.length) && /*#__PURE__*/React.createElement("div", {
    className: "EmbersNav-item-postfixIcon"
  }, expanded ? /*#__PURE__*/React.createElement("span", {
    tabIndex: 0,
    className: "EmbersNav-icon-arrow icon-expand-less"
  }) : /*#__PURE__*/React.createElement("span", {
    tabIndex: 0,
    className: "EmbersNav-icon-arrow icon-expand-more"
  })))));
};